export default __webpack_public_path__ + "static/media/preloader.f89b1271.gif";